import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Table } from 'antd'

@inject((store: any) => {
    const { insuranceCalculatorStore, popupStore, companiesStore } = store
    return { insuranceCalculatorStore, popupStore, companiesStore }
})
@observer
export default class ShabanTable extends Component<any, any> {
    render() {
        const { insuranceCalculatorStore, sets, drug, hmoCompanies, shaban, hmoPrices, shabanComparisons } = this.props
        let newKefelHeser = insuranceCalculatorStore.newKefelHeser
        const { loading } = insuranceCalculatorStore

        const columns = [
            {
                title: shaban.sub_name,
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {record.right_param_set_id != 20 ? sets[`id${record.right_param_set_id}`] : drug}
                        {checkIfIndeminficationOrCompensation(record)}
                    </span>
                )
            },
            {
                title: 'כיסויים',
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {getShabanRights(record).map((right, ind) => {
                            if (ind < 2)
                                return (
                                    <div className="icon-container" key={ind}>
                                        <div>{right.name}</div>
                                    </div>
                                )
                            if (ind == 2)
                                return (
                                    <div
                                        className="description"
                                        key={ind}
                                        style={{
                                            textDecoration: 'underline',
                                            color: 'blue',
                                            cursor: 'pointer'
                                        }}
                                        onClick={() =>
                                            this.props.popupStore.togglePopup('clarification', {
                                                title: `${shaban.sub_name} - ${
                                                    record.right_param_set_id != 20
                                                        ? sets[`id${record.right_param_set_id}`]
                                                        : drug
                                                }`,
                                                rights: getShabanRights(record)
                                            })
                                        }
                                    >
                                        קרא עוד...
                                    </div>
                                )
                        })}
                    </span>
                )
            },
            {
                title: 'התוכניות העדיפות',
                key: 'right_param_set_id',
                render: (_, record) => (
                    <span>
                        {shabanComparisons[record.right_param_set_id]
                            ? shabanComparisons[record.right_param_set_id].map((policy, ind) => {
                                  return (
                                      <div key={ind} className={`${policy.name == shaban.sub_name ? 'green' : ''}`}>
                                          {policy.name} ({hmoPrices.find(hmo => hmo.id == policy.id).price} ₪)
                                          {shabanComparisons[record.right_param_set_id].length !== 1 + ind ? ',' : ''}
                                      </div>
                                  )
                              })
                            : ''}
                    </span>
                )
            },
            {
                title: 'הבהרה',
                key: 'clarification',
                render: (_, record) => <span></span>
            }
        ]

        const getShabanRights = value => {
            const shabanRights = Object.entries(value.rights)
                .filter(
                    ([id, right]) =>
                        right.exist.find(policy => hmoCompanies[value.policies[policy].company_id]) ||
                        right.exist.find(policy => hmoCompanies[value.policies[policy].company_id]) == 0
                )
                .map(([id, right]) => {
                    right.indemnification =
                        value.policies[right.exist.find(policy => hmoCompanies[value.policies[policy].company_id])]
                            .rights[id] == 'שיפוי'
                    right.compensation =
                        value.policies[right.exist.find(policy => hmoCompanies[value.policies[policy].company_id])]
                            .rights[id] == 'פיצוי'
                    return right
                })

            return shabanRights
        }

        const checkIfIndeminficationOrCompensation = value => {
            let indemnification = true
            let compensation = true
            getShabanRights(value).map(right => {
                if (right.compensation) indemnification = false
                else if (right.indemnification) compensation = false
            })
            return indemnification ? (
                <div>
                    (<span className="green">שיפוי</span>)
                </div>
            ) : compensation ? (
                <div>
                    (<span className="blue">פיצוי</span>)
                </div>
            ) : (
                <div>
                    (<span className="green">שיפוי</span> /<span className="blue">פיצוי</span>)
                </div>
            )
        }

        let rows = newKefelHeser.sets
            ? Object.entries(newKefelHeser.sets)
                  .filter(
                      ([key, value]) =>
                          value.policies.length &&
                          value.policies.find(policy => hmoCompanies[policy.company_id]) &&
                          getShabanRights(value).length
                  )
                  .map(([key, value]) => {
                      value.right_param_set_id = key
                      return value
                  })
            : []

        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                dataSource={rows}
            />
        )
    }
}
